import { Button, Modal, Popover } from "antd"
import "./index.less"
import { ClearOutlined, QuestionCircleOutlined, } from "@ant-design/icons"
import { useCallback, useState } from "react"
import { NewChatIcon } from "./HelpRender/icons"
// export interface HeaderRightRender {
//   onHelp?: (open?: boolean) => void
//   onClear?: () => void
//   onNew?: () => void,
//   helpPage?: boolean,
//   helpOpen?: boolean
// }
// export default (props: HeaderRightRender) => {
export default (props) => {
  const { onHelp, onClear, onNew, helpPage, helpOpen } = props
  // const [helpOpen, setHelpOpen] = useState(false)
  const handleHelp = useCallback(() => {
    onHelp?.()
  }, [onClear])
  const handleClear = useCallback(() => {
    onClear?.()
  }, [onHelp])
  const handleNew = useCallback(() => {
    onNew?.();
    onHelp?.(true)
  }, [onHelp])
  return (
    <div style={{ textAlign: "right", padding: "15px 24px", lineHeight: '32px' }}>
      {/* <Popover content={"清除上下文"}>
        <Button
          onClick={handleClear}
          type='text'
          shape='circle'
          icon={<ClearOutlined></ClearOutlined>}
        ></Button>
      </Popover> */}
      <Popover content={window.chatCreateTitle || "新建对话"}>
        <Button
          onClick={handleNew}
          type='text'
          shape='circle'
          icon={<NewChatIcon ></NewChatIcon>}
        ><span style={{
          color: "#1C69FC"
        }}>{window.chatCreateTitle || ""}</span></Button>
      </Popover>
      {
        helpPage ? <Popover content={"帮助"}>
          <Button
            onClick={handleHelp}
            type='text'
            shape='circle'
            className="rightTopHelp"

            icon={<QuestionCircleOutlined style={{
              color: helpOpen ? "unset" : "#567FE6"
            }}></QuestionCircleOutlined>}
          ></Button>
        </Popover> : null
      }

    </div>
  )
}
